import { ListExtractions } from '../../../fragments/admin/price-extractions/ListExtractions'

const PriceExtractions = () => {
    return (
        <main>
            <ListExtractions />
        </main>
    )
}

export default PriceExtractions
